import React, { useState } from "react";
import API from "../../api/axios";
import "./Admin.css";

const AdminLogin = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await API.post("/admin/auth/login", form);

      localStorage.setItem("authToken", res.data.token);
      localStorage.setItem("adminInfo", JSON.stringify(res.data.admin));

      window.location.href = "/admin/dashboard";
    } catch (err) {
      console.error("❌ Login Error:", err);
      setError(err?.response?.data?.message || "Login failed. Try again.");
    }
  };

  return (
    <div className="admin-page">
      <form className="admin-login-box" onSubmit={handleSubmit}>
        <h2>Admin Login</h2>

        <input
          type="email"
          name="email"
          placeholder="Admin Email"
          value={form.email}
          onChange={handleChange}
        />

        <input
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
        />

        {error && <p className="error">{error}</p>}

        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default AdminLogin;
